module.exports = __webpack_public_path__ + "static/media/wisdom.f631550f.mp4";